module.exports = __webpack_public_path__ + "static/media/consulting_about_5.399d7dd9.webp";